import PropTypes from "prop-types";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/highlight/lib/styles/index.css";

const calculatePercentage = (value, total) => (value / total) * 100;
const RenderHighlights = ({
  pageIndex,
  getCssProperties,
  rotation,
  highlightData,
}) => {
  return (
    <div>
      {highlightData
        .filter((area) => area[0] === pageIndex)
        .map((area, idx) => {
          // Perform the calculations
          const height = calculatePercentage(area[2], area[3]);
          const top = calculatePercentage(area[1], area[3]);
          let left = 0;
          let width = 100;
          let background = "#FFC8D2";
          if (area.length === 5) {
            left = (area[4]?.offset / area[3]) * 100;
            width = (area[4]?.width / area[3]) * 100;
            background = "red";
          }
          const calculatedArea = {
            pageIndex: area[0],
            left: left,
            top: top - height,
            width: width,
            height: height,
          };
          return (
            <div
              key={idx}
              className="highlight-area"
              style={{
                background: background,
                opacity: 0.4,
                ...getCssProperties(calculatedArea, rotation),
              }}
            />
          );
        })}
    </div>
  );
};
RenderHighlights.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  getCssProperties: PropTypes.func.isRequired,
  rotation: PropTypes.number.isRequired,
  highlightData: PropTypes.array,
};

export { RenderHighlights };
